export interface IFullImage {
    caption: string,
    data: any,
    thumbnailData: any,
    rotate: number,
    zoom: number,
    position: {
        x: number,
        y: number
    }
}
